<template>
  <div>
    <div class="title">
      <span style="line-height: 40px">产品设计图</span>
    </div>
    <div class="title" style="float: right;">
      <van-button type="info" size="small" style="width: 100px" @click="onlineReport()">线上报修</van-button>
    </div>

    <van-row>
      <van-col span="24" class="pic">
        <img v-for="item in orderInfo" :src="item.photograph" class="img-thumbnail" alt="Cinque Terre"
          style="height: 370px !important;">
      </van-col>
    </van-row>

    <div style="margin: 200px 0 50px 0">
      <table class="table table-bordered" style="font-size: 14px">
        <tbody v-for="item in orderInfo">
          <tr>
            <td>生产编号</td>
            <td>{{ item.order_code }}</td>

          </tr>
          <tr>
            <td>产品名称</td>
            <td>{{ item.script_name }}</td>

          </tr>
          <tr>
            <td>尺寸</td>
            <td>{{ item.width }}*{{ item.height }}</td>
          </tr>
          <tr>
            <td>窗号</td>
            <td>{{ item.win_code }}</td>
          </tr>
          <tr>
            <td>地址</td>
            <td>{{ item.addr }}</td>
          </tr>
          <tr>
            <td>颜色</td>
            <td>内{{ item.inner_color }} 外{{ item.outer_color }}</td>
          </tr>
          <tr>
            <td>五金</td>
            <td>{{ item.wujinyanse }}</td>
          </tr>
          <tr>
            <td>安装位置</td>
            <td>{{ item.anzhuangweizhi }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="margin:50px 0 150px" v-if="show_product_show">
      <span style="float: left;margin-left: 10px">技术参数</span>
      <br />
      <div class="content-params">
        <div class="product-name">
          产品名称：{{ proview_list.name }}
        </div>
        <div class="item">
          <div :key="type" v-for="(type, index) in types"
            v-if="proview_list[`${type}_show`]  === 0 && proview_list[type].length != 0">
            <div class="label" v-if="proview_list[`${type}_show`] === 0">{{ typeTitle(type) }}</div>
            <div class="item-detail"
              v-if="proview_list[`${type}_show`] === 0 && proview_list[type].length != 0">
              <div class="item-detail-img">
                <div v-for="item in proview_list[type]">
                  <img :src="item" style="width:60%;" alt="" v-if="type !== 'video'" />
                  <video :src="item" controls="controls" style="width:60%;margin-top: 16px"
                    v-if="type === 'video'"></video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  name: "hl-info",
  data() {
    return {
      orderInfo: [],
      proview_list: [],
      types: ['price', 'product', 'color_card', 'sample', 'process', 'video'],
      show_product_show: true,
    }
  },
  methods: {
    typeTitle(type) {
      switch (type) {
        case 'product':
          return '成品展示：';
        case 'price':
          return '价格：';
        case 'color_card':
          return '色卡：';
        case 'sample':
          return '样角展示：';
        case 'process':
          return '工艺图解：';
        case 'video':
          return '视频：';
        default:
          return '';
      }
    },
    productCode() {
      return this.$route.query.id || this.$route.query.code || '';
    },
    onlineReport() {
      const id = this.productCode();
      if (!id) {
        alert('缺少产品编号');
        return;
      }
      this.$router.push({
        path: '/hl/repair',
        query: { id }
      });
    }
  },
  mounted() {
    const code = this.productCode();
    if (code) {
      sessionStorage.setItem('id', code);
      this.axios.get(`/qrcode/source_by_code?code=${code}`).then(res => {
        this.orderInfo = [res.data.data.order];
        if (res.data.data.product_show !== {}) {
          if (res.data.data.product_show.hasOwnProperty('cfg')) {
            const cfgJson = JSON.parse(res.data.data.product_show.cfg);
            res.data.data.product_show = {
              ...res.data.data.product_show,
              color_card_show: cfgJson.color_card_show,
              price_show: cfgJson.price_show,
              process_show: cfgJson.process_show,
              product_show: cfgJson.product_show,
              sample_show: cfgJson.sample_show,
              video_show: cfgJson.video_show
            };
          }
          this.proview_list = res.data.data.product_show || {};
          if (Object.values(this.proview_list).every(arr => arr.length === 0)) {
            // 当所有数组都为空时执行的代码
            this.show_product_show = false;
          }
        }
      })
      // axios({
      //   url: `https://gcds.thinkerx.com/api/qrcode/source?id=${this.$route.query.id}`,
      //   methods: 'get',
      // }).then(res => {
      //   this.orderInfo = [res.data.data.order];
      //   this.component = res.data.data.component;
      //   this.glass_data = res.data.data.glass;
      //   if (res.data.data.product_show !== {}) {
      //     if (res.data.data.product_show.hasOwnProperty('cfg')) {
      //       const cfgJson = JSON.parse(res.data.data.product_show.cfg);
      //       res.data.data.product_show = {
      //         ...res.data.data.product_show,
      //         color_card_show: cfgJson.color_card_show,
      //         price_show: cfgJson.price_show,
      //         process_show: cfgJson.process_show,
      //         product_show: cfgJson.product_show,
      //         sample_show: cfgJson.sample_show,
      //         video_show: cfgJson.video_show
      //       };
      //     }
      //     this.proview_list = res.data.data.product_show || {};
      //     if (Object.values(this.proview_list).every(arr => arr.length === 0)) {
      //       // 当所有数组都为空时执行的代码
      //       this.show_product_show = false;
      //     }
      //   }
      // })
    }

  }
}
</script>

<style scoped>
.title {
  float: left;
  height: 0;
  padding: 20px;
  font-size: 16px;
}

.pic {
  height: 200px;
  margin-top: 10%;
}

.content-params .product-name {
  text-align: start;
  padding: 32px 42px 0;
  font-weight: bold;
}

.content-params .item .label {
  text-align: start;
  padding: 38px 42px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/hl-info.vue